var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMedia = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.18441 11.3327H11.8103C13.0311 11.3327 13.6668 10.6935 13.6668 9.47215V2.52655C13.6668 1.30522 13.0311 0.666016 11.8103 0.666016H2.18441C0.96922 0.666016 0.333496 1.29951 0.333496 2.52655V9.47215C0.333496 10.6935 0.96922 11.3327 2.18441 11.3327ZM4.73293 6.10493C3.96219 6.10493 3.32646 5.46573 3.32646 4.68385C3.32646 3.90768 3.96219 3.25706 4.73293 3.25706C5.49805 3.25706 6.12815 3.90768 6.12815 4.68385C6.12815 5.46573 5.49805 6.10493 4.73293 6.10493ZM2.27442 10.197C1.76247 10.197 1.45305 9.88306 1.45305 9.35801V8.90143L3.03954 7.49747C3.28708 7.2749 3.53462 7.16646 3.79904 7.16646C4.06908 7.16646 4.35037 7.2806 4.59791 7.50318L5.6612 8.4791L8.32225 6.0821C8.59229 5.83669 8.89608 5.72255 9.21113 5.72255C9.51493 5.72255 9.83561 5.8424 10.0944 6.09352L12.5417 8.38779V9.36371C12.5417 9.88306 12.221 10.197 11.7259 10.197H2.27442Z",
    fill: "#BFBBCF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMedia);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/media.47a851c1ba54f13d12ebdb6720d194f2.svg";